import { Table } from 'antd';
import React, { useEffect, useState } from "react";
import { Button, Tooltip } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import styles from "./styles.css";
import CommonUtil from './CommonUtil.js';

const DataTable = ({wholeData }) => {
const [tableData, setTableData] = React.useState([]);
// const [dailyconfirmed_list, setDailyconfirmed_list] = React.useState([]);

 function getTableData(){
  var statewise = wholeData["statewise"]
  var state_data = []

  for (var i=1; i<=statewise.length; i = i + 1)  
    {  
      // console.log("key : ",i);
      if (true)  {
        try{
        	if(statewise[i]["state"] == "State Unassigned") {
        		continue
        	}
        	var obj = {}
    		  obj["key"] = i
        	obj["stateName"] = statewise[i]["state"]
        	obj["code"] = statewise[i]["statecode"]
        	obj["activeNumber"] = parseInt(statewise[i]["active"])
        	obj["active"] = statewise[i]["active"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        	obj["confirmed"] = statewise[i]["confirmed"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        	obj["recovered"] = statewise[i]["recovered"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        	obj["deaths"] = statewise[i]["deaths"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        	obj["lastupdatedtime"] = statewise[i]["lastupdatedtime"]
        	obj["statenotes"] = statewise[i]["statenotes"] ? (statewise[i]["statenotes"]) : "No notes"

          obj["deltaconfirmed"] = parseInt(statewise[i]["deltaconfirmed"])
          obj["deltarecovered"] = parseInt(statewise[i]["deltarecovered"])
          obj["deltadeaths"] = parseInt(statewise[i]["deltadeaths"])
          state_data.push(obj)

        }
        catch(err){
          // console.log("catch : ",err)
          ;
        }
      }
    }  

  state_data.sort( GetSortOrder("activeNumber") );

  state_data.reverse();

  console.log(" state_data : ", state_data)

  loadTableData(state_data)
 }


function GetSortOrder(prop){
   return function(a,b){
      if( a[prop] > b[prop]){
          return 1;
      }else if( a[prop] < b[prop] ){
          return -1;
      }
      return 0;
   }
}

 function loadTableData(tmpData){
  setTableData(tmpData)
 }

  useEffect(() => {
    getTableData()
    console.log("wholeData : ",CommonUtil.getNumberShortner(4434343434343))
  }, []); // <-- Have to pass in [] here!


const columns = [
  {
    title: 'State',
    dataIndex: 'stateName',
    key: 'stateName',
    width : "20%",
  },
  // {
  //   title: 'Statecode',
  //   dataIndex: 'code',
  //   key: 'code',
  //   responsive: ["lg"],
  // },
  {
    title: 'Active',
    dataIndex: 'active',
    key: 'active',
    responsive: ["sm"],
  },
  {
    title: 'Confirmed',
    dataIndex: 'confirmed',
    key: 'confirmed',
        render(text, record, index) {
          var deltaconfirmed = CommonUtil.getNumberShortner(record["deltaconfirmed"])
          return {
            props: {
              style: {}
            },
            children: <div>{text} <Tooltip title="Daily change"> 
                          <span className="daily-updates-record positive-color">({deltaconfirmed}+)</span>
                          </Tooltip>
                          </div>
          };
        }
  },
  {
    title: 'Recovered',
    dataIndex: 'recovered',
    key: 'recovered',
        render(text, record, index) {
          var deltarecovered = CommonUtil.getNumberShortner(record["deltarecovered"])
          return {
            props: {
              style: {}
            },
            children: <div>{text} <Tooltip title="Daily change"> 
                          <span className="daily-updates-record positive-color">({deltarecovered}+)</span>
                          </Tooltip>
                      </div>
          };
        }
  },
  {
    title: 'Deaths',
    dataIndex: 'deaths',
    key: 'deaths',
        render(text, record, index) {
          var deltadeaths = CommonUtil.getNumberShortner(record["deltadeaths"])
          return {
            props: {
              style: {}
            },
            children: <div>{text} <Tooltip title="Daily change"> 
                          <span className="daily-updates-record negative-color">({deltadeaths}+)</span>
                          </Tooltip>
                          </div>
          };
        }
  },
  {
    title: 'Lastupdatedtime',
    dataIndex: 'lastupdatedtime',
    key: 'lastupdatedtime',
    responsive: ["sm"],
  },
];


  return (
    <div>
        <div className='header'>
          <h1 className='title' style={{float:"left"}}>Covid realtime statewise stats</h1>
        </div>
        <Table columns={columns} dataSource={tableData} 
            pagination = {false}
            size = {"small"}
        	expandable={{
		      expandedRowRender: record => <p style={{ margin: 0 }}>{record.statenotes}</p>,
		      rowExpandable: record => record.name !== 'Not Expandable',
		    }}

         />

    </div>
  );
}

export default DataTable;
